<template>
  <div class="morning toronto">
    <div v-if="isMobile" class="mobile slider">
      <carousel>
        <slide :key="1" v-if="track1">
          <div class="grid__tracks">
            <div class="--title">
              2nd Floor
            </div>
            <div :class="['--slot', 't1', info.class]" v-for="info in track1" :key="info.company">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title" v-html="info.company">
              </p>
            </div>
          </div>
        </slide>
        <slide :key="3" v-if="track3">
          <div class="grid__tracks">
            <div class="--title">
              4th Floor
            </div>
            <div :class="['--slot', 't3', info.class]" v-for="info in track3" :key="info.company">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title" v-html="info.company">
              </p>
            </div>
          </div>
        </slide>
        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>
    <div class="grid__container" :style="gridStyle" v-else>
      <div class="grid__tracks" v-if="track1">
        <div class="--title">
          2nd Floor
        </div>
        <div :class="['--slot', 't1', info.class]" v-for="info in track1" :key="info.company">
          <div class="--slot__time">
            <p>{{ info.start }}</p>
            <p>{{ info.end }}</p>
          </div>
          <p class="--slot__title" v-html="info.company">
          </p>
        </div>
      </div>
      <div class="grid__tracks" v-if="track3">
        <div class="--title">
          4th Floor
        </div>
        <div :class="['--slot', 't3', info.class]" v-for="info in track3" :key="info.company">
          <div class="--slot__time">
            <p>{{ info.start }}</p>
            <p>{{ info.end }}</p>
          </div>
          <p class="--slot__title" v-html="info.company">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
  name: 'Day One Grid',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      track1: [
        { start: '4:00 PM', end: '4:30 PM', class:'long-title', company: '<b>Enabling institutional adoption through rational privacy</b><br>Moderator: Georgia Hanias - Input | Output, Midnight <br>Fahmi Syed - President, Midnight Foundation<<br>Neil Chopra - Sr. Director, Banking & Asset Management, Fireblocks<br>Alex McFarlane - Co-Founder, Keyring Network' }
      ],
      track3: [
        { start: '4:00 PM', end: '4:30 PM', class:'long-title', company: '<b>Building the Intelligent Frontier: What VCs and Operators Look for in AI Founders</b><br>Sophia Zhao - Partner, Alumni Ventures<br>Yiwen Li - Head of Venture & Alternative, Bay View Development Group<br>Lacey Wisdom - Partner, Protocol VC' }
      ],
      isMobile: false,
    }
  },
  computed: {
    gridStyle() {
      const trackCount = [this.track1, this.track3].filter(track => track && track.length).length;
      return {
        gridTemplateColumns: `repeat(${trackCount}, minmax(0, 1fr))`
      };
    },
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.handleResize);
    this.equalizeHeights();
  },
  updated() {
    this.equalizeHeights();
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
      this.equalizeHeights();
    },
    equalizeHeights() {
      this.$nextTick(() => {
        const cols1 = Array.from(this.$el.querySelectorAll('.t1.--slot'));
        const cols3 = Array.from(this.$el.querySelectorAll('.t3.--slot'));
        const count = Math.max(cols1.length, cols3.length);

        for (let i = 0; i < count; i++) {
          const a = cols1[i];
          const b = cols3[i];
          if (!a || !b) continue;

          a.style.removeProperty('height');
          b.style.removeProperty('height');

          const h1 = a.scrollHeight;
          const h2 = b.scrollHeight;
          const maxH = Math.max(h1, h2);

          a.style.setProperty('height', `${maxH}px`, 'important');
          b.style.setProperty('height', `${maxH}px`, 'important');
        }
      });
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss">
.toronto {
  .long-title {
    height: auto !important;
  }
  .agenda .grid__tracks .--slot__title b {
    font-size: 16px !important;
  }
}
</style>